<template>
    <div class="py-12 px-6">
        <div class="prose max-w-5xl mx-auto dark:text-white dark:prose-headings:text-white">
            <h1 class="text-2xl font-bold text-center">RoValue.com Terms of Service</h1>
            <p>Effective Date: September 17th 2024</p>
            <p>Welcome to RoValue.com. By accessing or using our services, you agree to the following terms and conditions. Please read them carefully before using our platform.</p>

            <h3>1. Acceptance of Terms</h3>
            <p>By accessing, registering, or using any of the services provided by RoValue.com, you agree to abide by these Terms of Service. If you do not agree, please refrain from using our services.</p>

            <h3>2. Eligibility</h3>
            <p>You must be at least 13 years old to use our services. By agreeing to these terms, you represent and warrant that you meet this age requirement.</p>

            <h3>3. User Accounts</h3>
            <p>To use certain features of RoValue.com, such as the trade calculator or posting trade ads, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. Any misuse of the account will result in immediate moderation.</p>

            <h3>4. User Conduct</h3>
            <p>You agree to use RoValue.com responsibly and ethically. This includes, but is not limited to:</p>
            <ul>
                <li>Not engaging in fraudulent activities, including scams or misleading trade ads.</li>
                <li>Respecting other users in the community.</li>
                <li>Complying with all applicable laws and regulations.</li>
                <li>Refraining from posting harmful, abusive, or inappropriate content.</li>
                <li>Not attempting to exploit, damage, or interfere with RoValue.com’s services, systems, or security measures.</li>
            </ul>

            <h3>5. Trading Policies</h3>
            <p>RoValue.com provides a platform for users to trade virtual in-game items. However, RoValue.com is not responsible for the outcomes of these trades. Users engage in trades at their own risk. RoValue.com does not guarantee the legitimacy or success of any trade conducted through its platform.</p>

            <h3>6. Intellectual Property</h3>
            <p>All content on RoValue.com, including but not limited to text, graphics, logos, icons, and images, is the property of RoValue.com and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or modify any part of the website without explicit permission.</p>

            <h3>7. Disclaimers</h3>
            <p>No Warranties: RoValue.com provides its services "as is" without any warranty, express or implied. We do not guarantee the accuracy of item values, the availability of services, or the reliability of trade partners.</p>
            <p>Limitation of Liability: RoValue.com will not be held liable for any direct, indirect, incidental, or consequential damages arising from the use of our services, including but not limited to issues related to trades, account breaches, or loss of virtual items.</p>

            <h3>8. Termination</h3>
            <p>RoValue.com reserves the right to suspend or terminate your account at any time for violation of these terms or other inappropriate behavior. We may also remove or modify services at any time without prior notice.</p>

            <h3>9. Privacy Policy</h3>
            <p>Your use of RoValue.com is subject to our Privacy Policy, which outlines how we collect, use, and protect your personal information.</p>

            <h3>10. Amendments to Terms</h3>
            <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting. Continued use of the platform after changes are posted will constitute acceptance of the revised terms.</p>

            <h3>Contact Information</h3>
            <p>If you have any questions regarding these Terms of Service, please contact us at support@rovalue.com.</p>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: 'Terms of Service'
})
</script>